import React from "react";
import { MessageCircle } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SuaJornadaVipComecaAqui() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const whatsappUrl = "https://wa.me/5527992826653";
  return <section data-section-id="17958" id="transforme-sua-gestão-agora" className="dark text-white relative w-full overflow-hidden">
      {}
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-[#1A1A1A]/90 to-black/80 opacity-100 z-0" />

      {}
      <div className="relative z-10 w-full h-full px-4 py-12 md:px-8 md:py-16 lg:py-24">
        <div ref={ref} className={`
            w-full max-w-5xl mx-auto border border-white/10 p-8 md:p-16 lg:p-20 
            flex flex-col items-center justify-center text-center gap-8
            transition-all duration-1000 ease-out
            ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}
          `}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-sans font-bold text-white tracking-tight leading-tight">
            Comece agora a transformar a gestão de sua empresa!
          </h2>
          
          <p className="text-gray-300 text-base md:text-lg max-w-2xl font-sans leading-relaxed">
            Não perca tempo com soluções que não agregam valor a sua gestão. Fale com nossos especialistas e descubra o potencial da tecnologia Linx para impulsionar seus resultados.
          </p>

          <div className="pt-4">
            <Button asChild size="lg" className="bg-[#FF006E] text-white hover:bg-[#FF006E]/90 hover:scale-105 font-bold text-lg px-8 py-6 h-auto shadow-[0_0_20px_rgba(255,0,110,0.3)] border-none transition-all animate-pulse">
              <Link to="https://api.whatsapp.com/send?phone=5527992826653&text=Bem%20vindo%20a%20Franquia%20Linx%20Vila%20Velha." newTab>
                <MessageCircle className="w-5 h-5 mr-2 fill-current" />
                FALAR NO WHATSAPP
              </Link>
            </Button>
          </div>

          <div className="mt-10 flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button asChild size="lg" className="w-full sm:w-auto bg-[#FF006E] text-white rounded-md shadow-lg hover:shadow-xl hover:scale-105 hover:-translate-y-0.5 transition-all duration-300 text-base px-8 h-14 font-semibold">
              
            </Button>
            <Button asChild variant="outline" size="lg" className="w-full sm:w-auto border border-[#25D366] text-[#25D366] hover:bg-[#25D366]/10 rounded-md text-base px-8 h-14 font-semibold transition-colors duration-300">
              
            </Button>
          </div>
        </div>
      </div>
    </section>;
}